import {Toast} from 'vant'
import { authCodeLogin } from '@/api/HttpRequestAPI'
import {setLoginToken} from '@/cache/Cache'
import { Message } from 'element-ui';

Toast.allowMultiple(true);
let loadingToast
/**
 * 弹出一个提示用户的信息
 * @param  {String} message [提示信息]
 * @param  {Number} status [默认为失败情况]
 * @return {[type]}         [description]
 */
const toast = (message = "") => {

  if(isMobile()) {
    Toast(message);
  } else {
    Message({
      message: message,
      type: 'warning'
    });
  }

};


/**
 * 显示加载中
 * @param message 提示信息
 * @param cancelable 是否可以取消
 * @param canceledOnTouchOutside 是否可以点击界面取消
 */
const showLoading = (message = "") => {
  if(!loadingToast) {
    loadingToast = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: message ? message : "加载中..."
    });
  }

};

/**
 * 隐藏加载中
 * @return {[type]} [description]
 */
const dismissLoading = () => {
  if(loadingToast) {
    loadingToast.clear()
    loadingToast = null
  }
};

const bytesToSize = (size) => {
  if(!size) {
    return '无文件大小'
  }
  if (size < 0.1 * 1024) {
    //小于0.1KB，则转化成B
    size = size.toFixed(2) + "B";
  } else if (size < 0.1 * 1024 * 1024) {
    // 小于0.1MB，则转化成KB
    size = (size / 1024).toFixed(2) + "KB";
  } else if (size < 0.1 * 1024 * 1024 * 1024) {
    // 小于0.1GB，则转化成MB
    size = (size / (1024 * 1024)).toFixed(2) + "MB";
  } else {
    // 其他转化成GB
    size = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  }

  // 转成字符串
  let sizeStr = size + "",
    // 获取小数点处的索引
    index = sizeStr.indexOf("."),
    // 获取小数点后两位的值
    dou = sizeStr.substr(index + 1, 2);

  // 判断后两位是否为00，如果是则删除00
  if (dou == "00") return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);

  return size;
}

const matchFileSuffixType = (fileName) => {
  // 后缀获取
  var suffix = ''
  // 获取类型结果
  var result = ''
  try {
    var flieArr = fileName.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false
    return result
  }
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
  // 进行图片匹配
  result = imglist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'image'
    return result
  }
  // 匹配txt
  var txtlist = ['txt']
  result = txtlist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'txt'
    return result
  }
  // 匹配 excel
  var excelist = ['xls', 'xlsx']
  result = excelist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'excel'
    return result
  }
  // 匹配 word
  var wordlist = ['doc', 'docx']
  result = wordlist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'word'
    return result
  }
  // 匹配 pdf
  var pdflist = ['pdf']
  result = pdflist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'pdf'
    return result
  }
  // 匹配 ppt
  var pptlist = ['ppt']
  result = pptlist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'ppt'
    return result
  }
  // 匹配 压缩文件
  var compresslist = ['zip', 'rar']
  result = compresslist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'compressFile'
    return result
  }
  // 匹配 视频
  var videolist = ['mp4', 'm2v', 'mkv']
  result = videolist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'video'
    return result
  }
  // 匹配 音频
  var radiolist = ['mp3', 'wav', 'wmv']
  result = radiolist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'radio'
    return result
  }
  // 其他 文件类型
  result = 'other'
  return result
}

const isMobile = () => {
  if( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
  )return true;
  return false;
};



export {
  toast,
  showLoading,
  dismissLoading,
  isMobile,
  bytesToSize,
  matchFileSuffixType,
};
